import React from 'react';
import ReactDOM from 'react-dom';
import App from './App'; // App.jsx'e bağlanır

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root') // public/index.html'deki root elemanına bağlanır
);
